module.exports = {
	"classes": [
		"changelog-page",
		"header-dark"
	],
	"title": "Auth0 Changelog",
	"metas": {
		"description": "Advanced identity management can be very hard. Very often, unnecessarily hard. At Auth0 we want to change that, by simplifying as much as possible."
	},
	"opengraph": {},
	"twittercard": {}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/changelog/metadata.json
// module id = 1115
// module chunks = 0